module.exports = __webpack_public_path__ + "static/staw-mostek_thumb-635ea026c93379c282f62faa797106b8.jpg";